module.exports = __webpack_public_path__ + "img/bg3.bdbc03e0.jpg";